module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/solution1_2@2x-7b27e4339c8f67568ec710ca98dfa46b.png";